export default __webpack_public_path__ + "static/defiyield-0e55b2bc3261be07a8e24b57c4629e7c.png";